<script setup lang="ts">
import { ElIcon } from 'element-plus'

import { BoxComponent, FlexComponent, PlatformHandle, TooltipComponent, TypographyComponent } from '../../..'
import HelpIcon from '../../../../assets/icons/help.svg?component'
import { useContentItemMetrics, useDetailFormatters } from '../composables'
import { type ContentItem, DETAILS_TOOLTIP_Z_INDEX, type ViewMode } from '../content-item-details.types'

import ContentItemDetailRow from './ContentItemDetailRow.vue'
const props = defineProps<{
  activeContentItem: ContentItem
  viewMode: ViewMode
}>()
const { formatDateTimeLong } = useDetailFormatters()
const { metrics } = useContentItemMetrics(() => props.activeContentItem)
</script>
<template>
  <BoxComponent>
    <BoxComponent :mb="24">
      <TypographyComponent variant="headline-small">Content Data</TypographyComponent>
    </BoxComponent>
    <FlexComponent :gap="16" direction="column">
      <ContentItemDetailRow label="Source">
        <PlatformHandle
          :handle="activeContentItem.profileHandle"
          :platform="activeContentItem.platform"
          class="content-item-details__source"
        />
      </ContentItemDetailRow>
      <ContentItemDetailRow label="Post date">
        <TypographyComponent variant="body-medium">
          {{ formatDateTimeLong(activeContentItem.createdAt) }}
        </TypographyComponent>
      </ContentItemDetailRow>
      <template v-if="metrics">
        <ContentItemDetailRow v-for="metric in metrics" :key="metric.label">
          <template #label>
            <FlexComponent :gap="4" align="center">
              <TypographyComponent variant="title-medium" :font-weight="600">{{ metric.label }}</TypographyComponent>
              <TooltipComponent v-if="metric.tooltip" placement="top" :z-index="DETAILS_TOOLTIP_Z_INDEX">
                <button type="button" class="content-item-details__metric-help" :aria-label="metric.tooltip.description">
                  <ElIcon :size="16">
                    <HelpIcon />
                  </ElIcon>
                </button>
                <template #content>
                  <FlexComponent direction="column" :gap="4">
                    <TypographyComponent v-if="metric.tooltip.title" variant="title-medium">
                      {{ metric.tooltip.title }}
                    </TypographyComponent>
                    <TypographyComponent variant="body-medium">{{ metric.tooltip.description }}</TypographyComponent>
                  </FlexComponent>
                </template>
              </TooltipComponent>
            </FlexComponent>
          </template>
          <TypographyComponent variant="body-medium">{{ metric.value }}</TypographyComponent>
        </ContentItemDetailRow>
      </template>
    </FlexComponent>
    <el-divider />
  </BoxComponent>
</template>
<style scoped lang="scss">
.content-item-details__metric-help {
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  color: var(--secondary-48);
  cursor: help;
}
</style>
